/// <reference path="../../typings/tsd.d.ts" /> 
/// <reference path="../../typings/jquery/jquery.d.ts"/>
module warsApp.directives {

    export class FormStepDisplayOnly implements IDirective {
        public controller = ['$scope', FormStepDisplayOnlyController];
        public controllerAs = 'controller';
        public templateUrl = './app/views/directives/FormStepDisplayOnly.html';
        public restrict: string = "E";

        public scope: any = {
            processConfiguration: '=',
            stepIndex: '=',
            conditions: '='
        };

        public link(scope: IWorkflowWorkspaceScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, controller: WorkflowWorkspaceController): void
        { }
    }


    export interface IFormStepDisplayOnlyScope extends ng.IScope {
        stepIndex: number;
        form: Wars.Domain.Model.Form;
        conditions: Wars.Domain.Model.Conditions.Condition[];
        currentStep: Wars.Domain.Model.FormStep;
        getConditionNameById(id: string) : string;
    }

    export class FormStepDisplayOnlyController implements IController {
        private scope: IFormStepDisplayOnlyScope;

        constructor($scope: IFormStepDisplayOnlyScope) {
            this.scope = $scope;
            this.scope.currentStep = this.scope.form.mySteps[this.scope.stepIndex];
            this.scope.getConditionNameById = (id: string) => this.getConditionNameById(id);
        }

        private getConditionById(id: string): Wars.Domain.Model.Conditions.Condition {
            if (!this.scope.conditions) return undefined;
            return Enumerable.from(this.scope.conditions).singleOrDefault(i => i.id === id);
        }

        public getConditionNameById(id: string): string {
            if (id === undefined) return "";
            var condition = this.getConditionById(id);
            if (condition) return condition.name;
            return "";
        }
    }
}

warsApp.registerDirective('FormStepDisplayOnly', []);